module.exports = __webpack_public_path__ + "static/media/gov-block.14d5afce.jpg";